module.exports = __webpack_public_path__ + "img/tablet.3b74c4e6.svg";